import { render } from "./TrendChart.vue?vue&type=template&id=2a3e48cc&scoped=true"
import script from "./TrendChart.vue?vue&type=script&lang=js"
export * from "./TrendChart.vue?vue&type=script&lang=js"

import "./TrendChart.vue?vue&type=style&index=0&id=2a3e48cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3e48cc"]])

export default __exports__